import { Component, Input } from '@angular/core';

@Component({
  selector: 'ca-avatar-stack',
  templateUrl: './avatar-stack.component.html',
  styleUrls: ['avatar-stack.component.scss'],
  standalone: false,
})
// Can provide an imageId instead of an image url, to use filedownloadurl within this component.
// If provided, image url will always be prioritised over imageId.
export class AvatarStackComponent {
  @Input()
  avatars: { fullName: string; image?: string; imageId?: string }[] = [];

  @Input()
  maxAvatars = 4;

  @Input()
  size: 'small' | 'large' = 'large';
}
